import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { getInvoiceDownloadUrlApiV1InvoiceDownloadUrlGet } from "@/client";
import { Button } from "@/components/ui/button";
import { getFileNameFromFilePath } from "@/lib/utils";

export function DownloadInvoiceButton({ id }: { id: string }) {
  const { t } = useTranslation();
  const { mutateAsync: downloadInvoice, isPending } = useMutation({
    mutationFn: getInvoiceDownloadUrlApiV1InvoiceDownloadUrlGet,
  });

  return (
    <Button
      disabled={isPending}
      onClick={async () => {
        try {
          const presignedUrl = await downloadInvoice({ id });

          const link = document.createElement("a");
          link.href = presignedUrl;

          const filename = getFileNameFromFilePath(id) || "invoice.pdf";
          link.setAttribute("download", filename);

          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);
        } catch (error) {
          console.error("Error downloading invoice:", error);
        }
      }}
    >
      {isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : t("Download")}
    </Button>
  );
}
